var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3323 6.66602H31.6657C22.2376 6.66602 17.5235 6.66602 14.5946 9.59495C11.6657 12.5239 11.6656 17.2379 11.6656 26.666V53.3327C11.6656 62.7607 11.6657 67.4747 14.5946 70.4037C17.5235 73.3327 22.2376 73.3327 31.6657 73.3327H48.3323C57.7603 73.3327 62.4743 73.3327 65.4033 70.4037C68.3323 67.4747 68.3323 62.7607 68.3323 53.3327V26.666C68.3323 17.2379 68.3323 12.5239 65.4033 9.59495C62.4743 6.66602 57.7603 6.66602 48.3323 6.66602Z",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3344 15H46.6677",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63.334H40.0333",
    stroke: "#141B34",
    strokeWidth: 6.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.d7c7b4009598a82e39cf8a3b0c51eed1.svg";
export { ForwardRef as ReactComponent };